import { Box, Container, Stack, Typography } from "@mui/material";
import Admins from "@/templates/Admins";
import { BackButton } from "@/organism";
import useCreate from "./useCreate";

export const Create = () => {
  const { isLoading, handleAdmCreate } = useCreate();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Stack direction={"column"} gap={1}>
          <BackButton to={"/admins"}>관리자 목록</BackButton>
          <Typography
            component={"h1"}
            variant="h5"
            fontWeight={"bold"}
            gutterBottom
          >
            관리자 등록
          </Typography>
        </Stack>
      </Box>
      <Admins.CreateForm onSubmit={handleAdmCreate} isLoading={isLoading} />
    </Container>
  );
};
